import { checkValidDate, getFormattedDateStringNoTime } from "@/composables/dateField.js";
import { ERROR_MESSAGES } from "@/constants/CommonWebConstants";
import { convertToFloat } from "@/composables/util";
import { LOGGER } from "@/util/logger";
import { clone } from "@/util/clone";
export const requiredRule = (value) => {
  if (!value || value?.toString()?.trim()?.length == 0) {
    return "Required";
  }

  return true;
};

export const secondCharacterCountRule = (value) => {
  if (value && value.length < 50) {
    return value.length + " of 50 Characters Required";
  }
  return true;
};

export const greaterThanZeroRule = (value) =>
  (Number.parseFloat(value?.replaceAll(",", "")) || 0) >= 0 || "Cannot be less than 0";

export const greaterThanZeroRuleExclusive = (value) =>
  (Number.parseFloat(value?.replaceAll(",", "")) || 0) > 0 || ERROR_MESSAGES.GREATER_THAN_ZERO;

export const elementTotalPercentEqualToOneHundredRule = (element) => {
  const cloneElement = clone(element);
  return (
    convertToFloat(cloneElement.elemPctState2, 0) +
      convertToFloat(cloneElement.elemPctState3, 0) +
      convertToFloat(cloneElement.elemPctState4, 0) ===
      100 || ERROR_MESSAGES.TOTAL_PERCENT_EQUAL_TO_100
  );
};

export const elementOneQuantityMustBeGreaterThanZero = (element) =>
  element.elemQtyState2 > 0 ||
  element.elemQtyState3 > 0 ||
  element.elemQtyState4 > 0 ||
  ERROR_MESSAGES.ATLEAST_ONE_GREATER_THAN_ZERO;

export const lessThanOneRule = (value) =>
  (Number.parseFloat(value?.replaceAll(",", "")) || 0) <= 1 || "Cannot be greater than 1";

export const lessThanValueRule = (value, maxValue) => {
  if (typeof value === "string") {
    value = value?.toString().replaceAll(",", "");
  }
  if (Number.parseFloat(value) > maxValue) {
    return `Cannot be greater than ${maxValue}`;
  } else {
    return true;
  }
};

export const greaterThanOrEqualValueRule = (value, minValue) => {
  if (typeof value === "string") {
    value = value?.toString().replaceAll(",", "");
  }
  if (Number.parseFloat(value) < minValue) {
    return `Cannot be less than ${minValue}`;
  } else {
    return true;
  }
};

export const validDateFormatRule = (value) => {
  if (value && !checkValidDate(value)) {
    return "Date must follow format MM/DD/YYYY";
  } else {
    return true;
  }
};
export const validDateRangeRule = (value, max, min) => {
  if (value && (new Date(value) > new Date(max) || new Date(value) < new Date(min))) {
    return `Valid range ${getFormattedDateStringNoTime(min)} to ${getFormattedDateStringNoTime(max)}`;
  } else {
    return true;
  }
};

export const validDatesRule = (value, invalidDates) => {
  let formattedInvalidDates = [];
  for (const invlaidDate of invalidDates ?? []) {
    formattedInvalidDates.push(new Date(invlaidDate).toLocaleDateString());
  }
  if (formattedInvalidDates.includes(new Date(value).toLocaleDateString())) {
    return `Invalid date chosen`;
  } else {
    return true;
  }
};

export const valueInRangeRule = (value, minValue, maxValue) => {
  if (value) {
    if (typeof value === "string") {
      value = value?.toString().replaceAll(",", "");
    }
    const floatValue = Number.parseFloat(value) || 0;
    const floaMinValue = Number.parseFloat(minValue) || 0;
    const floatMaxValue = Number.parseFloat(maxValue) || 0;

    if (floatValue > floatMaxValue || floatValue < floaMinValue) {
      return `Valid range  ${minValue} to ${maxValue}`;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

export const valueLengthInRangeRule = (value, minValue) => {
  if (value.length < minValue) {
    return `Must be at least ${minValue} characters`;
  } else {
    return true;
  }
};

export const valueCannotBeRule = (value, restrictedValue) => {
  if (value == restrictedValue) {
    return `Cannot be ${restrictedValue}`;
  } else {
    return true;
  }
};

export const restrictionSpanIdRule = (value, restrictedValueOne, restrictedValueTwo, restrictedValueThree) => {
  if (value != null && value == restrictedValueOne) {
    return `Value cannot be identical to ${restrictedValueOne}`;
  } else if (value != null && value == restrictedValueTwo) {
    return `Value cannot be identical to ${restrictedValueTwo}`;
  } else if (value != null && value == restrictedValueThree) {
    return `Value cannot be identical to ${restrictedValueThree}`;
  } else if (value != null && value?.substring(0, 2) != restrictedValueOne?.substring(0, 2)) {
    return `First two digits must be the same as the first two digits for ${restrictedValueOne}`;
  } else {
    return true;
  }
};

export const shouldbeEqual = (value, matchValue) => {
  if (typeof value === "string") {
    value = value?.toString().replaceAll(",", "");
  }
  if (convertToFloat(value, 0) == matchValue) {
    return true;
  } else {
    return `must be ${matchValue}`;
  }
};

/**
 * @description This method validate if value provided in arugument is valid URL or not.
 * @param value It is string value.
 */
export const valueIsValidURLRule = (value) => {
  try {
    new URL(value);
    return true;
  } catch (err) {
    LOGGER.logException(err);

    return `Valid URL must start with http(s):`;
  }
};

export const valueInLimitsRule = (value, min, max) => {
  if (Number.parseInt(value) >= min && Number.parseInt(value) <= max) {
    return true;
  } else if (value) {
    return `Valid range ${min} to ${max}`;
  }
};

export const validFilenameRule = (value = "") => {
  const rg1 = /^[^\\/:*?"<>|]+$/; // Forbidden characters: \ / : * ? " < > |
  const rg3 = /^(nul|aux|prn|con|lpt\d|com\d)(\.|$)/i; // Forbidden file names

  if (!rg1.test(value) || value.startsWith(".") || rg3.test(value)) {
    return `Invalid file name`;
  }
  return true;
};

export const minYearLengthRule = (value, charCount) => {
  if (!value || value.length < charCount) {
    return `Required - ${charCount} digit year`;
  } else {
    return true;
  }
};
